import { getDateMinus30DaysComputed } from './datetime'

export const getFilterByComponentId = (componentId) => {
    return {
        Predicates: [
            {
                PropertyName: "ComponentId",
                Operator: "EQ",
                Value: `${componentId}`,
                TypeHint: "Integer"
            }
        ]
    }
}
export const getDefaultTaskListFilters = () => {
    return {
        Predicates: [
            {
                "PropertyName": "TaskRunAfter",
                "Operator": "GTE",
                "Value": getDateMinus30DaysComputed(),
                "TypeHint": "DateTime"
            }
        ]
    }
}
export const getEmptyFilters = () => {
    return { Predicates: [] }
}